import styled from "styled-components";

export const TextAreaContainer = styled.div`
  .textarea {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    margin-bottom: 16px;

    textarea {
      width: 100%;
      display: block;
      resize: none;
      box-sizing: border-box;
    }

    span {
      color: rgba(0, 0, 0, 0.54);
      font-size: 14px;
    }
  }
`;
